export default "__VITE_PUBLIC_ASSET__b219da55__"